export default "__VITE_ASSET__bd5397ec__"